export const WIDTH_CARD = 200;
export const GAP_CARD = 16;
export const MOBILE_LEFT_OFFSET_CAROUSEL = 848;
